export { MinusSmall as default } from './MinusSmall';
